import { Injectable } from '@angular/core';
import { Http, Response,Headers, ResponseContentType } from '@angular/http';
import { IEmpEligibleWorkDetail } from './empeligibleworkdetail';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';


@Injectable()
export class EmployeeEligibilityReportService {
    private _empEligibleReportUrl = CONFIGURATION.baseServiceUrl + 'eligibilityreportservice/';
    constructor(private _http: Http) { }
    getReportReferenceData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._empEligibleReportUrl + 'getEligibilityReferenceData',{headers:headers})
            .map((response: Response) => response.json().eligibilityReferanceData)
            .catch(this.handleError);
    }

    getEmployeeEligibleReports(filterCriteria: any): Observable<IEmpEligibleWorkDetail[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'getEligibilityReportData?WorkYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '&TypeOfHours=' + filterCriteria.selectedTypeOfHours
            + '&UnionStatus=' + filterCriteria.selectedUnionStatus;
        return this._http.get(this._empEligibleReportUrl + fileName,{headers:headers})
            .map((response: Response) => <IEmpEligibleWorkDetail[]>response.json().eligibilityReportData)
            .catch(this.handleError);
    }
    downloadPDFReport(filterCriteria: any): any {
        const fileName = 'processEligibilityReportPDFUpload?WorkYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '&TypeOfHours=' + filterCriteria.selectedTypeOfHours
            + '&UnionStatus=' + filterCriteria.selectedUnionStatus;

        // window.open(this._empEligibleReportUrl + fileName, '_bank');
        const url = this._empEligibleReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        // headers.append('Authorization', 'JWT ' + localStorage.getItem('id_token'));
       return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
    downloadExcelReport(filterCriteria: any): any {
        let fileName = 'processEligibilityServiceReportExcelUpload?WorkYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '&TypeOfHours=' + filterCriteria.selectedTypeOfHours
            + '&UnionStatus=' + filterCriteria.selectedUnionStatus;

        // window.open(this._empEligibleReportUrl + fileName, '_bank');
        const url = this._empEligibleReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }
}



// WEBPACK FOOTER //
// ./src/app/EmployeeEligibilityReport/employeeEligibilityReport.service.ts